import { useEffect, useState } from "react";
import axios from "axios";
import API_URL, { IMAGE_URL } from "../config/config";
import "../css/cart.css";
import { useNavigate } from "react-router-dom";
function Cart() {
  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    axios
      .get(`${API_URL}/cart/${user.id}`)
      .then((res) => {
        setCartItems(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
const tax = total * 0.0825;
const shipping = total > 100 ? 0 : 10;

const grandTotal = total + tax + shipping;
  const updateQuantity = async (cartId, quantity) => {

    if (quantity < 1) return;

    try {

        await axios.put(
            `${API_URL}/cart/${cartId}`,
            { quantity }
        );

        setCartItems((items) =>
            items.map((item) =>
                item.id === cartId
                    ? { ...item, quantity }
                    : item
            )
        );

    } catch (error) {
        console.log(error);
    }
};

const removeItem = async (cartId) => {

    try {

        await axios.delete(`${API_URL}/cart/${cartId}`);

        setCartItems(
            cartItems.filter((item) => item.id !== cartId)
        );

    } catch (error) {

        console.log(error);

    }

};

  return (
    <div className="cart-container">

      <h1 className="cart-title">🛒 My Shopping Cart</h1>

      {cartItems.length === 0 ? (

        <div className="empty-cart">
          Your cart is empty.
        </div>

      ) : (

        <>
          {cartItems.map((item) => (
<div className="cart-item" key={item.id}>

    <img
       src={`${IMAGE_URL}${item.image}`}
        alt={item.product_name}
        className="cart-image"
    />

    <div className="cart-details">

    <h3>{item.product_name}</h3>

    <p>Price: ${item.price}</p>

    <div className="quantity-box">
        <button
            onClick={() => updateQuantity(item.id, item.quantity - 1)}
            disabled={item.quantity <= 1}
        >
            -
        </button>

        <span>{item.quantity}</span>

        <button
            onClick={() => updateQuantity(item.id, item.quantity + 1)}
        >
            +
        </button>
    </div>

    <p>
        Subtotal: $
        {(item.price * item.quantity).toFixed(2)}
    </p>

    <button
        className="remove-btn"
        onClick={() => removeItem(item.id)}
    >
        Remove
    </button>

</div>

            </div>

          ))}

        <div className="cart-summary">

    <h2>Order Summary</h2>

    <div className="summary-row">
        <span>Subtotal</span>
        <span>${total.toFixed(2)}</span>
    </div>

    <div className="summary-row">
        <span>Shipping</span>
        <span>
            {shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}
        </span>
    </div>

    <div className="summary-row">
        <span>Tax (8.25%)</span>
        <span>${tax.toFixed(2)}</span>
    </div>

    <hr />

    <div className="summary-row total-row">
        <span>Grand Total</span>
        <span>${grandTotal.toFixed(2)}</span>
    </div>

    <button
        className="checkout-btn"
        onClick={() => navigate("/checkout")}
    >
        Proceed to Checkout
    </button>

</div>

        </>

      )}

    </div>
  );
}

export default Cart;